import { Component,  inject, signal } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CustomRouteService } from 'src/app/pages/custom-route/services';
import { WebSocketService } from 'src/chatbot/service/webSocket.service';
import { RestService } from 'src/app/services';
import { WebsocketLaravelReverb } from '../home/services/websocket-laravel-reverb';
import { CHANNEL_DEV_ACTIONS, RESTART, START_TOKEN } from '../home/config/constants';
import { environment } from 'src/environments/environment';
import dayjs from 'dayjs';

@Component({
  standalone: true,
  imports: [
    IonicModule
  ],
  templateUrl: './fitur-dev-panel.component.html',
  styleUrls: ['./fitur-dev-panel.component.scss'],
})
export class FiturDevPanelComponent {
    private _websocketLaravelReverbService = inject(WebsocketLaravelReverb);
    private _webSocketService = inject(WebSocketService);
    private _customRouteService = inject(CustomRouteService);
    private _restService = inject(RestService);

    public routeToken =  this._customRouteService.token;
    public routeData = signal([]);

    ngOnInit(){
      this.routeData.set([]);
      this._restService.getFiturRoutes().subscribe(res => this.routeData.set(res));
    }

    startNewExperience(){
      this.restartImmersiveApp();
      window.location.replace("http://localhost:4200");
    }

    restartExperience(){
      if (!this.routeToken())
        return;

      this.startImmersiveAppByActualToken();
      setTimeout(() => {
        window.location.replace(`${environment.urlAtril}/home/route/${this.routeToken()}`);
      }, 150);
    }

    getChatbotWelcome(){
      this._webSocketService.sendWelcome();
    }

    public restartImmersiveApp(){
      this._websocketLaravelReverbService.sendMessage(
        CHANNEL_DEV_ACTIONS,
        RESTART,
        { msg: true }
      )
    }

    public startImmersiveAppByActualToken(){
      if (!this.routeToken())
        return;

      this._websocketLaravelReverbService.sendMessage(
        CHANNEL_DEV_ACTIONS,
        START_TOKEN,
        { token: this.routeToken() }
      )
    }

    public startImmersiveAppByToken(token){
      if (!token)
        return;

      this._websocketLaravelReverbService.sendMessage(
        CHANNEL_DEV_ACTIONS,
        START_TOKEN,
        { token: token }
      )
    }

    public getDate(date: string): string {
      return dayjs(date).format('DD/MM HH:mm')
    }

    public startRoute(token: string): void {
      this.startImmersiveAppByToken(token);
      setTimeout(() => {
        window.location.replace(`${environment.urlAtril}/home/route/${token}`);
      }, 150);
    }
}